<div fxLayout.gt-md="row" fxLayout="column" fxLayoutAlign="space-between stretch">

  <mat-card fxFlex="100">
    <mat-card-content>
      <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="20px">
        <div class="mat-card-content-label" fxLayoutAlign="space-between center" fxLayout="row"
             fxLayoutGap.lt-sm="15px" fxLayout.lt-sm="column">
          <label>
            Rooms |
            <span *ngIf="isNewRoomFeed" class="text-warning ifc-link" (click)="toggleNewRoomSettings()"
                  matBadgeColor="warn" [matBadge]="roomSettings.length" matBadgeOverlap="false">
              Show
              Existing
            </span>
            <span *ngIf="!isNewRoomFeed" class="text-success ifc-link" (click)="toggleNewRoomSettings()"
                  matBadgeColor="accent" [matBadge]="newRoomSettings.length" matBadgeOverlap="false">Show New</span>
          </label>

          <button type="button" class="add-action-button" mat-flat-button color="accent" (click)="saveRoomSettings()"
                  [disabled]="!isRoomSettingsDirty || loading">
            <mat-icon>done</mat-icon> Save
          </button>
        </div>

        <ng-container *ngIf="isNewRoomFeed">
          <mat-card *ngFor="let roomSetting of pagedNewRoomSettings" class="contrast">
            <mat-card-content fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="20px" fxLayout.lt-lg="column" fxLayoutAlign.lt-lg="center space-between">
              <mat-form-field>
                <mat-label>Room Name</mat-label>
                <input type="text" matInput placeholder="Room Name" [(ngModel)]="roomSetting.roomName" readonly>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Room Type</mat-label>
                <mat-select [(ngModel)]="roomSetting.roomType" #roomType="ngModel" required>
                  <mat-option *ngFor="let item of roomTypeEnum | enumKeyValue:'asc'" [value]="item.value">
                    {{ item.value == 0 ? 'Not A Room' : getEnumKeyForDisplay(item.key) }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="roomType.errors?.['required']">
                  Room Type is <strong>required</strong>
                </mat-error>
                <mat-hint *ngIf="roomSetting.suggestedRoomType !== undefined && roomSetting.roomType !== roomSetting.suggestedRoomType"
                          class="text-warning ifc-link" align="end" (click)="useSuggestedRoomType(roomSetting)">
                  set to
                  {{getEnumKeyForDisplay(roomTypeEnum[roomSetting.suggestedRoomType])}}?
                </mat-hint>
              </mat-form-field>
            </mat-card-content>
          </mat-card>

          <div *ngIf="newRoomSettings.length == 0 && !loading">
            No new rooms to configure, perfect!
          </div>

          <div *ngIf="newRoomSettings.length == 0 && loading">
            Loading room settings...
          </div>

          <mat-paginator *ngIf="newRoomSettings.length" (page)="onNewRoomsPageChange($event)"
                         [pageIndex]="newRoomSettingsPageIndex" [length]="newRoomSettings.length" [pageSize]="pageSize"
                         aria-label="Select page" hidePageSize="true">
          </mat-paginator>
        </ng-container>

        <ng-container *ngIf="!isNewRoomFeed">
          <mat-card *ngFor="let roomSetting of pagedRoomSettings" class="contrast">
            <mat-card-content fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="20px" fxLayout.lt-lg="column" fxLayoutAlign.lt-lg="center space-between">
              <mat-form-field>
                <mat-label>Room Name</mat-label>
                <input type="text" matInput placeholder="Room Name" [(ngModel)]="roomSetting.roomName" readonly>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Room Type</mat-label>
                <mat-select [(ngModel)]="roomSetting.roomType" #roomType="ngModel" required>
                  <mat-option *ngFor="let item of roomTypeEnum | enumKeyValue:'asc'" [value]="item.value">
                    {{ item.value == 0 ? 'Not A Room' : getEnumKeyForDisplay(item.key) }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="roomType.errors?.['required']">
                  Room Type is <strong>required</strong>
                </mat-error>
              </mat-form-field>
              <button mat-icon-button color="accent" aria-label="Remove" (click)="removeRoomSetting(roomSetting);">
                <mat-icon>delete</mat-icon>
              </button>
            </mat-card-content>
          </mat-card>

          <div *ngIf="roomSettings.length == 0 && !loading">
            No rooms have been configured.
          </div>

          <div *ngIf="roomSettings.length == 0 && loading">
            Loading room settings...
          </div>

          <mat-paginator *ngIf="roomSettings.length" (page)="onRoomsPageChange($event)"
                         [pageIndex]="roomSettingsPageIndex" [length]="roomSettings.length" [pageSize]="pageSize"
                         aria-label="Select page" hidePageSize="true">
          </mat-paginator>
        </ng-container>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card ngStyle.gt-md="max-width: 450px;">
    <mat-card-content>
      <h2>Documentation</h2>

      <p>This configuration maps zones or spaces that are defined in CAD to a concise set of rooms that is used to build out a house.</p>
      <h3>How are Rooms Used</h3>
      <p>
        Rooms are used to determine room specific furniture, a dinning table in the
        <code>Meals</code> room for example. It also specifies the type of lighting that is used in that room.
      </p>
      <p>
        They are also used to determine room specific materials and products, for example the
        <code>Master Bedroom</code> and
        <code>Ensuite</code> may get higher end products installed.
      </p>
      <p>Rooms are also used for selections on the interactive floor plan.</p>
      <p>Skirting and Cornice is also disabled on a per room basis for example wet rooms and outdoor areas.</p>
      <h3>Choosing a Room</h3>
      <p>When choosing a room consider the room that would have the most suitable furniture and finish.</p>
      <p>
        Combination rooms like
        <code>Meals and Living</code> will be split down the middle and suitable furniture added to each half.
      </p>
      <p>
        Choose
        <code>Not A Room</code> for zones that don't represent a room, such as a zone for the entire ground floor.
      </p>
      <p>If you need a room type that is not currently listed, please contact Situ systems to discuss your requirements.</p>

    </mat-card-content>
  </mat-card>

</div>
